import { render, staticRenderFns } from "./WhereAreWeGoing.vue?vue&type=template&id=528405b8&scoped=true"
import script from "./WhereAreWeGoing.vue?vue&type=script&lang=js"
export * from "./WhereAreWeGoing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528405b8",
  null
  
)

export default component.exports